module.exports = __webpack_public_path__ + "static/slouching-towards-bethlehem-7ae49cd0c45bcf827f035bc58f1d8740.jpg";